export const CREATE_LOAN_SENT_CONFIRM = "CREATE_LOAN_SENT_CONFIRM";

export function confirm(loanId) {
  return {
    type: CREATE_LOAN_SENT_CONFIRM,
    loanId,
  };
}
